export default __webpack_public_path__ + "static/media/arrow.07ae1798.svg";